// extracted by css-extract-rspack-plugin
module.exports =  {"rootSection":"e664a63cf1"};